<template>
  <div id="tianbaoxiangqingLess">
    <van-sticky>
      <van-nav-bar
        :title="title"
        left-text="返回22"
        left-arrow
        @click-left="onClickLeft"
      />
    </van-sticky>
    <!-- 返回顶部 -->
    <div class="toTopIcon" v-if="btnFlag">
      <van-icon name="upgrade" @click.stop="backTop" class="go-top" />
    </div>
    <div class="xinxi">
      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="5">
            <div class="blue-box"></div>
            期号：
          </van-col>
          <van-col span="7" class="twoLine">
            {{ exeno }}
          </van-col>
          <van-col span="5">
            <div class="blue-box"></div>
            截止时间：
          </van-col>
          <van-col span="7" class="twoLine">
            {{ priceDate }} {{ lateReportTime }}
          </van-col>
        </van-row>
      </div>

      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="5">
            <div class="blue-box"></div>
            任务名称：
          </van-col>
          <van-col span="19" class="twoLine">{{ taskName }}</van-col>
        </van-row>
      </div>

      <div style="margin-bottom: 0.3rem">
        <van-row>
          <van-col span="6">
            <div class="blue-box"></div>
            监测点筛选：
          </van-col>
          <van-col span="18" class="twoLine">
            <!-- <van-button @click="jump">点击跳转</van-button> -->
            <van-search
              v-model="dropdownInput"
              @focus="hideTabs"
              @input="fuzzyQuery"
              placeholder="请输入监测点名称"
            />
            <div class="wrapper" v-if="showDrop" @click="showTabs">
              <van-list
                class="block"
                v-model="loading1"
                :finished="finished"
                finished-text=""
                @load="onLoad"
              >
                <van-cell
                  v-for="(item, index) in inputTable"
                  :key="index"
                  :title="item.text"
                  @click.stop="dropClick(item.value, item.text)"
                />
              </van-list>
            </div>
          </van-col>
        </van-row>
      </div>
    </div>
    <van-sticky offset-top="1.0558rem">
      <div class="boxTitle">
        <van-row type="flex" justify="center" align="center">
          <van-col span="2" align="center">序号</van-col>
          <van-col span="7" align="center">商品</van-col>
          <van-col span="8" align="center">本期价格</van-col>
          <van-col span="4" align="center">上期价格</van-col>
          <van-col span="3" align="center">环比%</van-col>
        </van-row>
      </div>
    </van-sticky>
    <div class="table">
      <van-card v-for="items in stationList" :key="items.value">
        <template #title>
          <div class="title" :id="items.value">
            {{ items.text }}
            <van-divider style="margin: 0; color: #2f2f2f" />
          </div>
        </template>
        <template #desc>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text=""
            @load="onLoad"
            style="padding-bottom: 0.2rem"
          >
            <div
              :class="[index % 2 == 0 ? 'even' : 'odd']"
              v-for="(item, index) in list"
              :key="index"
            >
              <div v-if="item.StationCode === items.value">
                <van-row type="flex" justify="center" align="center">
                  <van-col span="2" align="center">
                    <div style="width: 50%;background-color: red;color:#fff" v-if="!item.isGoods && ((item.itemNumbersShow && !item.itemNumbers) || (item.originBrandShow && !item.originBrand))">
                        {{ index + 1 }}
                    </div>
                    <div v-else-if="item.isGoods || (!item.itemNumbersShow && !item.originBrandShow)">
                        {{ index + 1 }}
                    </div>
                    <div v-else  style="width: 50%;background-color: green;color:#fff">
                      {{ index + 1 }}
                    </div>
                  </van-col>
                  <van-col
                    span="7"
                    :style="{
                      color:
                        item.VarietyCodeNew == item.VarietyCode || item.isGoods == 1 ||
                        (item.ThisPrice == 0 && item.ThisPrice != '') ||
                        (item.hbzks !== null&& item.hbNum > item.hbzks && item.hbNum > 0) ||
                        (item.hbjks !== null && Math.abs(item.hbNum) > item.hbjks && item.hbNum < 0)
                          ? 'red'
                          : 'blue',
                    }"
                    class="contentLimit"
                    @click="clickStoreName(item, index)"
                    >{{ item.VarietyName }}--{{ item.StandardName }}--{{
                      item.TargetName
                    }}</van-col
                  >
                  <van-col span="1" align="center">&emsp;</van-col>
                  <van-col span="8">
                    <div
                      class="input"
                      :class="{ bianhui: item.ifShow == false || item.isGoods == 1}"
                    >
                      <input
                        v-model="item.ThisPrice"
                        :class="{ bianhui: dis }"
                        @blur="changePrice(index)"
                        :style="{
                          background:
                            item.ThisPrice == 0 && item.ThisPrice != ''
                              ? '#efe7e7'
                              : '',
                        }"
                        type="number"
                        oninput="if(value<0) value=0; if(value>999999)value=999999"
                        required
                      />
                    </div>
                    {{ item.UnitName }}
                  </van-col>
                  <van-col span="2" align="right">{{ item.ringPrice }}</van-col>
                  <!-- 环比：（本期数-上期数）/上期数×100% -->
                  <van-col
                    span="3"
                    align="right"
                    :style="{ color: item.styleColor }"
                    v-model="item.hbNum"
                    >{{ item.hbNum }}</van-col
                  >
                  <van-col span="1" align="center">&emsp;</van-col>
                </van-row>
              </div>
            </div>
          </van-list>
          <div
            style="height: 1rem; background-color: #f0f2f1"
            v-if="lastStation === items.value"
          ></div>
        </template>
      </van-card>
    </div>
    <div class="bottom">
      <van-row type="flex" justify="center" align="center">
        <!-- <van-col span="5" :class="{ bianhui: dis }" offset="1">
          <v-button class="btn" @click="daoru">导入上期</v-button>
        </van-col> -->
        <van-col span="5" :class="{ bianhui: dis }" offset="1">
          <v-button class="btn" @click="save">保存</v-button>
        </van-col>
        <van-col span="5" :class="{ bianhui: dis }" offset="1">
          <v-button class="btn" @click="shangbao">上报</v-button>
        </van-col>
        <van-col span="5" offset="1">
          <v-button class="btn" @click="chaKanRiZhi">查看日志</v-button>
        </van-col>
      </van-row>
    </div>
    <!-- 商品说明弹窗start -->
    <van-popup v-model="showDetial" :style="{ width: '75%' }">
      <van-field v-model="shopIndex1" label="序号" disabled />
      <van-field
        v-model="shopName"
        label="商品"
        rows="1"
        autosize
        type="textarea"
        disabled
      />
      <div style="display: flex;border-bottom: 1px solid  #ebedf0;margin-left: 0.2rem;">
        <div class="goodIs">无此品种</div>
        <van-checkbox v-model="isGoods" shape="square" @change="changeIsGoods"></van-checkbox>
      </div>
      <van-field
        v-model="bqPrice"
        label="本期"
        :formatter="formatter"
        :disabled="isGoods"
        class="g_disabled"
        type="number"
      />
      <van-field
        v-if="ifShow == 1"
        v-model="brand"
        label="品牌"
        type="text"
        maxlength="50"
      />
      <van-field v-if="originBrandShow&& !isGoods" v-model="originBrand"
                 label="品牌产地"
                 class="long-label"
                 type="text"
                 maxlength="50"/>
      <van-field v-if="itemNumbersShow&& !isGoods" v-model="itemNumbers"
                 label="数量"
                 type="text"/>
      <van-field
        v-model="content"
        rows="3"
        autosize
        label="波动原因说明"
        type="textarea"
        maxlength="50"
        class="long-txt"
        placeholder="请输入波动原因说明"
        show-word-limit
      />
      <!-- <van-field
        v-model="comments"
        rows="3"
        autosize
        label="备注"
        type="textarea"
        maxlength="50"
        placeholder="请输入备注"
        show-word-limit
      /> -->
      <van-row type="flex" justify="center" align="center">
        <van-col span="6">
          <v-button class="btn" @click="closeBasic()">取消</v-button>
        </van-col>
        <van-col span="6" offset="4">
          <v-button class="btn" :class="{ bianhui: dis }" @click="saveBasic()"
            >保存</v-button
          >
        </van-col>
      </van-row>
    </van-popup>
    <!-- 商品说明弹窗end -->
    <!-- 查看日志弹窗start -->
    <van-popup
      v-model="showLog"
      position="bottom"
      :style="{ height: '60%', backgroundColor: '#f0f2f1' }"
      id="logList"
    >
      <van-sticky>
        <div class="boxTitle">
          <van-row type="flex" justify="center" align="center">
            <van-col span="24" align="center">日志详情</van-col>
          </van-row>
        </div>
      </van-sticky>
      <div class="logTable" style="height: calc(100% - 1rem); overflow-y: auto">
        <div class="no-con" v-if="logList.length == 0">暂无数据</div>
        <div class="logBox" v-for="(item, index) in logList" :key="index">
          <van-row type="flex" justify="center" align="center">
            <van-col span="10">{{ item.editUser }}</van-col>
            <van-col span="10">{{ item.editTime }}</van-col>
          </van-row>
          <van-row type="flex" justify="center" align="center">
            <van-col span="20">{{ item.recordType }}</van-col>
          </van-row>
          <van-row type="flex" justify="center" align="center">
            <van-col span="20">{{ item.detailInfo }}</van-col>
          </van-row>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { loading } from "@/common/loading";
import {
  saveRow,
  upOK,
  getDateRecord,
  checkLogin,
  getStationList,
  dataGridNew,
} from "@/api/baseMsg";
import { Toast } from "vant";
// import { Dialog } from 'vant'
export default {
  name: "tianbaoxiangqingLess",
  data() {
    return {
      title: "市级代填报详情",
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      taskCode: this.$route.query.taskCode,
      exeno: this.$route.query.exeno,
      taskID: this.$route.query.taskId,
      stateId:this.$route.query.stateId,
      // shopId: this.$route.query.shopId,
      shispflag: this.$route.query.shispflag, //市审核
      shengspflag: this.$route.query.shengspflag, //市审核 //1蓝2绿3灰
      active2: this.$route.query.active2, //日报周报选中状态
      priceDate: this.$route.query.priceDate,
      lateReportTime: this.$route.query.lateReportTime,
      dis: true, //审核状态的事项不可提交
      showDetial: false, //展示商品说明
      shopIndex: "",
      shopName: "", //商品名称
      bqPrice: "", //本期价格
      bqPriceSave:'',
      contentSave:"",
      isGoods:"", //无此品种  1无，0有
      brand: "", //品牌
      content: "", //说明
      comments: "", //备注
      originBrand:'',//品牌产地
      originBrandShow:false,
      itemNumbersShow:false,
      itemNumbers:'',//数量
      ifShow: "", //为0的时候不显示 品牌文本框,1时显示
      shopIndex1: "",
      ids: [], //数据
      showLog: false, //展示日志列表
      logList: [], //日志列表
      showLogDetial: false, //展示日志详情
      loginStatus: true,
      levelNum: this.$route.query.levelNum, //用户等级

      dlrflag: this.$route.query.dlrflag, //待录入
      dsbflag: this.$route.query.dsbflag, //待上报
      ythflag: this.$route.query.ythflag, //已退回

      taskName: "", //任务名称
      stationName: "", //监测点
      stationList: [],
      shopIdList: [], //taskId
      StationCode: "",
      lastStation: "", //判断是否是最后一个监测点
      btnFlag: false,
      dropdownInput: "",
      inputTable: [],
      showDrop: false,
    };
  },
  created() {
    this.init()
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    init() {
      // 初始化暂未定
      loading(true)
      this.checkLogin();
      if (this.loginStatus) {
        this.getStationList();
      }
    },
    getStationList() {
      getStationList({
        taskCode: this.taskCode,
        exeno: this.exeno,
        active: 1,
        // stateId:this.stateId,
      }).then((res) => {
        res.forEach(i=> {
          i.value = i.codeValue
          i.text = i.codeName
        })
        this.stationList = res;
        this.inputTable = res;
        this.dataGridNew();
      });
    },
    dropClick(code, name) {
      this.dropdownInput = name;
      this.showDrop = !this.showDrop;
      this.jump(code);
    },
    hideTabs() {
      //隐藏展示滚动tabs
      this.fuzzyQuery(this.dropdownInput);
      this.showDrop = true;
    },
    showTabs() {
      //展示滚动tabs
      this.showDrop = false;
    },
    fuzzyQuery(keyWord) {
      //搜索筛选方法
      // if(keyWord.length==0) {
      //     return
      // }
      const arr = [];
      for (let i = 0; i < this.stationList.length; i++) {
        if (this.stationList[i].text.indexOf(keyWord) >= 0) {
          arr.push(this.stationList[i]);
        }
      }
      // console.log(this.inputTable);
      this.inputTable = arr;
    },
    // 跳转至监测点指定位置
    jump(value) {
      this.$nextTick(() => {
        setTimeout(() => {
          document
            .getElementById(value)
            .scrollIntoView({ behavior: "smooth", block: "center" });
        });
      });
    },
    //置顶图标
    backTop() {
      const that = this;
      const timer = setInterval(() => {
        const ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    },
    // 为了计算距离顶部的高度，当高度大于130显示回顶部图标，小于130则隐藏
    scrollToTop() {
      const that = this;
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
      that.btnFlag = that.scrollTop > 130;
      // that.isBarNav = that.scrollTop > 10;
    },

    dataGridNew() {
      if ((this.dsbflag != 2 || this.ythflag != 2) && this.shispflag == 3) {
        this.dis = false; //3是灰色 代表还未审核 //1蓝2绿3灰
      } else {
        this.dis = true;
      }
      if (this.active2 == 1) {
        this.dis = true;
      }
      this.StationCode = this.stationList.map((item) => item.value).join(",");
      var last = this.stationList.slice(-1);
      this.lastStation = last.length > 0 ? last[0].value : '';
      dataGridNew({
        taskCode: this.taskCode,
        ExeNo: this.exeno,
        StationCode: this.StationCode,
      }).then((result) => {
        let hbNum; //环比
        const res = result.dataList
        const columnMap = result.columnMap
        const arr = Object.keys(columnMap)
        arr.forEach(i=> {
          res.forEach(j=> {
            if(i == j.VarietyCode) {
              if(columnMap[i].itemNumbers) {
                j.itemNumbersShow = true
              }else {
                j.itemNumbersShow = false
              }
              if(columnMap[i].originBrand) {
                j.originBrandShow = true
              }else {
                j.originBrandShow = false
              }
            }
          })
        })
        for (let i = 0; i < res.length; i++) {
          this.shopIdList.push(res[i].shopId);
          this.taskName = res[i].taskName;
          this.stationName = res[i].stationname;

          let ringPrice = res[i].ringPrice; //上期 ringPrice
          let thisPrice = res[i].ThisPrice; //本期 ThisPrice
          if (res[i].ThisPrice == -1 || res[i].ThisPrice == "-") {
            res[i].ThisPrice = "";
            res[i].hbNum = "-";
            continue;
          }
          if (!Number(ringPrice) || ringPrice == 0 || !Number(thisPrice)) {
            res[i].hbNum = "-";
            continue;
          }
          ringPrice = parseFloat(ringPrice);
          thisPrice = parseFloat(thisPrice);
          hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
          if (hbNum == Infinity || isNaN(hbNum)) {
            res[i].hbNum = "-";
          } else {
            if (hbNum > 0) {
              res[i].styleColor = "red";
            } else if (hbNum < 0) {
              res[i].styleColor = "green";
            } else {
              res[i].styleColor = "black";
            }
            if (
              hbNum.toString().indexOf(".") != -1 &&
              hbNum.toString().split(".")[1].length > 2
            ) {
              hbNum = hbNum.toFixed(2);
            }
            res[i].hbNum = hbNum;
            res[i].ifShow = this.isUp(res[i].stateId);
          }
        }
        this.list = res;
        this.shopIdList = Array.from(new Set(this.shopIdList)); //去重
        loading(false);
      });
    },
    isUp(ext) {
      //未填报0,未提交1,县市区已退回89,市级已退回90,省级已退回99('0','1','89','90','99')案件状态
      return ["0", "1", "89", "90", "99"].indexOf(ext) !== -1;
    },
    //保存价格采集
    saveRow(type, editType) {
      loading(true)
      saveRow({
        taskID: this.taskID,
        TempCode: this.code,
        ExeNo: this.exeno,
        priceDate: this.priceDate,
        StationCode: this.StationCode,
        // shopTaskId: this.shopId,
        shopTaskId: this.shopIdList.toString(),
        json: JSON.stringify(this.list),
        taskCode: this.taskCode,
        editType: editType,
      }).then((res) => {
        if (res.success) {
          if (type == 1) {
            this.upOK();
            return;
          }
          loading(false)
          Toast.success(res.info);
        } else {
          Toast({
            message: res.info.replace(/<\/br>/g, "\n"),
            position: "center",
            overlay: true,
          });
          Toast.setDefaultOptions({ duration: 3600 });
          setTimeout(() => {
            if (res.ids == undefined) return;
            if (res.ids != "") {
              this.ids = JSON.parse(JSON.stringify(res.ids.split(",")));
              let listIndex;
              for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].VarietyCode == this.ids[0]) {
                  listIndex = i;
                }
                for (let j = 0; j < this.ids.length; j++) {
                  if (this.list[i].VarietyCode == this.ids[j]) {
                    this.list[i].VarietyCodeNew = this.ids[j];
                    continue;
                  }
                }
              }
              this.clickStoreName(this.list[listIndex], listIndex);
            }
          }, 3600);
        }
      });
    },
    //上报
    upOK() {
      upOK({
        shopTaskIds: this.shopIdList.toString(),
        // exeno: this.exeno,
        // taskCode:this.taskCode,
        // stationCode:this.StationCode,
      }).then((res) => {
        if (res.code == 200) {
          loading(false)
          Toast.success(res.message)
          this.dis = true;
        } else {
          this.ids = res.ids;
          Toast.fail(res.info.replace(/<\/br>/g, "\n"));
        }
      });
    },
    onClickLeft() {
      this.$router.push({
        path: "/agentFill/agentFill",
        query: {
          active: this.active,
          active2: this.active2,
        },
      });
      //   }
    },
    onLoad() {
      //初始化table
      loading(true);
      // this.dataGridNew()
      setTimeout(() => {
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        this.finished = true;
      }, 1000);
    },
    //环比实时变化
    changePrice(i) {
      let hbNum;
      let ringPrice = this.list[i].ringPrice; //上期 ringPrice
      let thisPrice = this.list[i].ThisPrice; //本期 ThisPrice

      if (!Number(thisPrice)) {
        this.list[i].hbNum = "-";
        return;
      }
      if (thisPrice.split(".").length - 1 > 1) {
        Toast("本期价格输入格式不正确请重新输入!");
        return;
      }
      thisPrice = parseFloat(thisPrice).toFixed(this.list[i].report_digits);
      this.list[i].ThisPrice = thisPrice;
      if (!Number(ringPrice) || ringPrice == 0) {
        this.list[i].hbNum = "-";
        return;
      }
      ringPrice = parseFloat(ringPrice);
      thisPrice = parseFloat(thisPrice);
      hbNum = ((thisPrice - ringPrice) / ringPrice) * 100;
      if (hbNum == Infinity || isNaN(hbNum)) {
        this.list[i].hbNum = "-";
      } else {
        if (
          hbNum.toString().indexOf(".") != -1 &&
          hbNum.toString().split(".")[1].length > 2
        ) {
          hbNum = hbNum.toFixed(2);
        }
        if (parseInt(hbNum) > 0) {
          this.list[i].styleColor = "red";
          this.list[i].HB = "<span style='color:red'>涨" + hbNum + "<span>";
        } else if (parseInt(hbNum) < 0) {
          this.list[i].styleColor = "green";
          this.list[i].HB = "<span style='color:green'>跌" + hbNum + "<span>";
        } else {
          this.list[i].styleColor = "black";
        }
        this.list[i].hbNum = hbNum;
      }
    },
    daoru() {
      loading(true)
      //导入上期
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].ringPrice == "-" || this.list[i].ringPrice == "" || this.list[i].isGoods == 1) {
          continue;
        } else {
          this.list[i].ThisPrice = this.list[i].ringPrice;
          if (this.list[i].ringPrice != 0) {
            this.list[i].styleColor = "black";
            this.list[i].hbNum = 0;
          }
        }
      }
      setTimeout(()=> {
        loading(false)
      },1000)
    },
    //判断是否复核判断条件
    ifCheckSaveRow() {
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (
          this.ifNullOrEmpty(item.Memo, 0) &&
          ((item.ThisPrice == 0 && item.ThisPrice != "") ||
          (item.hbzks !== null&& item.hbNum > item.hbzks && item.hbNum > 0) ||
          (item.hbjks !== null && Math.abs(item.hbNum) > item.hbjks && item.hbNum < 0))
        ) {
          Toast("数据" + item.VarietyName + "请填写波动原因说明!");
          this.clickStoreName(this.list[i], i);
          return false;
        }
        if(item.ThisPrice && item.originBrandShow && !item.originBrand && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写品牌产地!")
          return false;
        }
        if(item.ThisPrice && item.itemNumbersShow && !item.itemNumbers && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写数量!")
          return false;
        }
      }
      return true;
    },
    ifCheckUpOk() {
      for (let i = 0; i < this.list.length; i++) {
        const item = this.list[i];
        if (this.ifNullOrEmpty(item.Memo, 1)) {
          Toast("数据" + item.VarietyName + "说明的字数不能太少，至少2个文字!");
          this.clickStoreName(this.list[i], i);
          return false;
        }
        if (
          this.ifNullOrEmpty(item.Memo, 0) &&
          ((item.ThisPrice == 0 && item.ThisPrice != "") ||
          (item.hbzks !== null&& item.hbNum > item.hbzks && item.hbNum > 0) ||
          (item.hbjks !== null && Math.abs(item.hbNum) > item.hbjks && item.hbNum < 0))
        ) {
          Toast("数据" + item.VarietyName + "请填写波动原因说明!");
          this.clickStoreName(this.list[i], i);
          return false;
        }
        if(item.ThisPrice && item.originBrandShow && !item.originBrand && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写品牌产地!")
          return false;
        }
        if(item.ThisPrice && item.itemNumbersShow && !item.itemNumbers && !item.isGoods) {
          this.clickStoreName(this.list[i], i)
          Toast("数据"+item.VarietyName+"请填写数量!")
          return false;
        }
      }
      return true;
    },
    ifNullOrEmpty(obj,type) {
      var regu = "^[ ]+$";
      var re = new RegExp(regu);
      if (type==0 &&  (typeof obj == "undefined" || obj == null || obj == "" || re.test(obj))
      ) {
        return true;
      }else if( !(typeof obj == "undefined" || obj == null || obj == "" || re.test(obj)) && obj.length<2 && type==1 ){
        return true;
      } else {
        return false;
      }
    },
    save() {
      //保存
      if (!this.ifCheckSaveRow()) return;
      // this.saveRow(0, "2");
      if(this.ythflag==1){//退回并修改 4  //1蓝2绿3灰
        this.saveRow(0,"4")
      }else{
         this.saveRow(0,"2")
      }
    },
    shangbao() {
      if (!this.ifCheckUpOk()) return;
      //上报
      this.$dialog
        .confirm({
          message: "上报之后不能再进行修改，是否确认上报?",
        })
        .then(() => {
          this.saveRow(1, "5");
          //   this.upOK();
        })
        .catch(() => {});
    },
    // 点击商品名
    clickStoreName(item, index) {
      //   if (!this.dis) {
      this.shopIndex1 = index + 1;
      this.shopName =
        item.VarietyName + "--" + item.StandardName + "--" + item.TargetName; //商品
      this.bqPrice = item.ThisPrice; //本期价格
      this.bqPriceSave = item.ThisPrice
      this.isGoods = item.isGoods == 1 ? true : false
      this.contentSave = item.Memo; //说明
      this.brand = item.brand; //品牌
      this.ifShow = item.bring_previous_remark; //为0的时候不显示 品牌文本框,1是显示
      this.content = item.Memo; //说明
      this.comments = item.comments;
      this.shopIndex = index;
      this.itemNumbersShow = item.itemNumbersShow
      this.originBrandShow = item.originBrandShow
      this.itemNumbers = item.itemNumbers ? item.itemNumbers : ''
      this.originBrand = item.originBrand ? item.originBrand : ''
      this.showDetial = true;
      //   }
    },
    // 关闭弹框
    closeBasic() {
      this.showDetial = false;
    },
    //保存弹框信息
    saveBasic() {
      if (this.bqPrice > 999999) {
        this.bqPrice = 999999;
      } else if (this.bqPrice < 0) {
        this.bqPrice = 0;
      }
      this.list[this.shopIndex].ThisPrice = this.bqPrice; //本期价格
      this.list[this.shopIndex].brand = this.brand; //品牌brand
      this.list[this.shopIndex].Memo = this.content; //说明
      this.list[this.shopIndex].comments = this.comments; //备注
      this.list[this.shopIndex].isGoods = this.isGoods?1:0; //无此品种
      if(this.originBrandShow) {
        this.list[this.shopIndex].originBrand = this.originBrand //品牌产地
      }
      if(this.itemNumbersShow) {
        this.list[this.shopIndex].itemNumbers = this.itemNumbers //数量
      }
      this.changePrice(this.shopIndex);
      this.showDetial = false;
    },
    changeIsGoods() {
      if(this.isGoods == true) {
        this.bqPriceSave = this.bqPrice
        this.bqPrice = 0.00
        this.contentSave = this.content
        this.content = '无此品种'
      }else {
        this.bqPrice = this.bqPriceSave
        this.content = this.contentSave == '无此品种' ? '' : this.contentSave
      }
    },
    // 查看日志按钮
    chaKanRiZhi() {
      this.showLog = true;
      loading(true)
      this.getDateRecord();
    },
    //查看日志
    getDateRecord() {
      getDateRecord({
        taskId: this.taskID,
        exeNo: this.exeno,
        stationCode: this.StationCode,
      }).then((res) => {
        this.logList = res;
        loading(false)
      });
    },
    //监测登陆状态 houcc 2021.07.24
    checkLogin() {
      checkLogin({}).then((res) => {
        if (!res.success) {
          // nativeJSBridge.logout();
          this.$router.push({ path: "/loginOld" });
        }
        this.loginStatus = res.success;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#tianbaoxiangqingLess {
  background: #f0f2f1;
  height: 100%;
  /deep/.van-nav-bar__text:active {
    background-color: transparent;
  }
  //置顶图标
  .toTopIcon {
    z-index: 100;
    position: fixed;
    bottom: 6%;
    right: 6%;

    .van-icon {
      font-size: px2rem(100);
      color: #ffa800;
    }
  }
  .xinxi {
    padding-left: 0.463rem;
    padding-top: 0.3rem;
    width: calc(100vw - 0.463rem);
    height: 2.8rem;
    background-color: #ffffff;
    font-size: px2rem(36);
    color: #4494f3;
    vertical-align: middle;
  }
  .blue-box {
    display: inline-block;
    width: 0.06rem;
    height: 0.26rem;
    margin-right: 0.09rem;
    background-color: #4494f3;
  }
  .boxTitle {
    height: 1rem;
    line-height: 1rem;
    background-color: #4494f3;
    color: #ffffff;
    font-size: px2rem(36);
  }
  .table {
    height: calc(100% - 5.7158rem);
    .input {
      display: inline-block;
      vertical-align: middle;
      //   height: 0.9rem;
      //   line-height: 0.9rem;
      width: 1.3rem;
      background-color: #fff;
      border: px2rem(1) solid #4494f3;
      input {
        // margin: 0;
        // border: 0;
        // height: 0.7rem;
        // vertical-align: middle;
        // width: 1.3rem;
        // outline: none;
        margin: 0;
        border: 0;
        height: 0.8rem;
        vertical-align: middle;
        width: 1.3rem;
        outline: none;
        text-align: right;
      }
    }
    .even {
      display: flex;
      font-size: px2rem(36);
      background-color: #f2fbfe;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100vw;
        height: 50px;
      }
    }
    .odd {
      display: flex;
      font-size: px2rem(36);
      background-color: #e0f7ff;
      color: #3e3e3e;
      /deep/.van-row {
        width: 100vw;
        height: 50px;
      }
    }
    .contentLimit {
      //表格内容商品列限制三行展示
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background-color: #fff;
    .btn {
      display: inline-block;
      width: 2rem;
      height: 1rem;
      line-height: 1rem;
      border-radius: 1rem;
      background-color: #3486e8;
      color: #ffffff;
      font-size: px2rem(45);
      text-align: center;
      vertical-align: middle;
    }
  }
  //提交上报的事项 底部按钮变灰
  .bianhui {
    pointer-events: none;
    filter: grayscale(1);
  }

  .btn {
    display: inline-block;
    width: 2rem;
    height: 1rem;
    line-height: 1rem;
    border-radius: 1rem;
    background-color: #3486e8;
    color: #ffffff;
    font-size: px2rem(45);
    text-align: center;
    vertical-align: middle;
  }
  /deep/.van-field--disabled .van-field__label {
    color: #000;
  }
  /deep/.van-field__control:disabled {
    color: #000;
    font-weight: bold;
    -webkit-text-fill-color: #000;
  }
  /deep/ .van-field__label {
    color: #000;
  }
  /deep/.van-field__control {
    color: #000;
    font-weight: bold;
    -webkit-text-fill-color: #000;
  }
  /deep/.van-cell {
    padding: 5px 16px;
    line-height: 0.9rem !important;
  }
  /deep/.van-field__label {
    width: 1.2rem !important;
  }
  /deep/ .long-label .van-field__label {
    width: 1.5rem !important;
  }
  /deep/ .long-txt .van-field__label {
    width: 1.8rem !important;
    line-height: 0.5rem !important;
    margin-top: 0.2rem;
    margin-left: -0.23rem;
  }
  .goodIs {
    width: 1.9rem;
    font-size: 0.37037rem;
    line-height: 1.2rem;
    height: 1.2rem;
  }
  .g_disabled {
    /deep/.van-field__control:disabled {
      color: #c8c9cc!important;
      -webkit-text-fill-color: #c8c9cc!important;
    }
  }
  .logTable {
    height: calc(100% - 1rem);
    .no-con {
      color:#3e3e3e;
      font-size:px2rem(36);
      text-align:center;
      margin: 0 auto;
      padding: 2rem 0;
    }
  }
  .even {
    display: flex;
    font-size: px2rem(36);
    background-color: #f2fbfe;
    color: #3e3e3e;
    /deep/.van-row {
      width: 100vw;
      height: 50px;
    }
  }
  .odd {
    display: flex;
    font-size: px2rem(36);
    background-color: #e0f7ff;
    color: #3e3e3e;
    /deep/.van-row {
      width: 100vw;
      height: 50px;
    }
  }
  .logTitle {
    width: 100%;
    padding: px2rem(10) 0;
    color: #000;
    font-size: px2rem(60);
    font-weight: bold;
    text-align: center;
  }
  .logText {
    width: 100%;
    padding: px2rem(10) 0;
    color: #000;
    font-size: px2rem(40);
    font-weight: bold;
    text-align: left;
  }
  .logBox {
    margin: px2rem(20) px2rem(15);
    padding: 0.1rem 0;
    padding-bottom: 0.35rem;
    background-color: #fff;
    font-size: px2rem(36);
    /deep/.van-row {
      margin-top: 0.15rem;
    }
    // border-radius: 25px;
  }
  .twoLine {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height:0.48rem;
  }
  .title {
    height: 30px;
    font-size: 16px;
    // color: #4494f3;
    color: #000;
    background-color: #ffffff;
    line-height: 30px;
    text-indent: 1em;
    display: inline-block;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  /deep/.van-card {
    padding: 0;
  }
  /deep/.van-search {
    height: 0.7rem;
  }
  .wrapper {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    height: 100vh;
    position: fixed;
    // top: 3.63rem;
    left: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .block {
    position: relative;
    width: 100%;
    max-height: 50vh;
    background-color: #fff;
    color: #000;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}
</style>